<template>
    <Dialog :common-dialog="addonDialog" :dialog-width="1500">
        <template v-slot:title>
            <v-layout>
                <v-flex>
                    <span class="text-capitalize">Select Add-Ons</span>
                    ({{ getSelectedItem }})
                </v-flex>
                <v-flex class="text-right">
                    <v-btn style="height: 32px !important" class="custom-bold-button mr-2" depressed
                        :disabled="pageLoading" color="cyan white--text" v-on:click="save_line_item()">Save</v-btn>
                    <v-btn style="height: 32px !important" class="custom-bold-button" depressed :disabled="pageLoading"
                        v-on:click="$emit('close', true)">Close</v-btn>
                </v-flex>
            </v-layout>
        </template>
        <template v-slot:body>
            <div>
                <div class="d-flex mb-2">
                    <v-text-field v-model="search" class="line-item-header-text px-0 v-slot-m-none"
                        placeholder="Search..." dense filled solo :disabled="pageLoading" clearable flat color="cyan"
                        style="max-width: 400px" />
                    <v-btn style="height: 32px !important" class="custom-bold-button ml-2" depressed
                        :disabled="pageLoading" v-on:click="find_items()" color="cyan white--text">Search</v-btn>
                </div>
                <div>
                    <div class="d-flex grey lighten-4">
                        <div class="font-weight-600 py-2 text-center d-flex justify-center" style="width: 10%">
                            <v-checkbox v-on:change="update_all_line_item($event)" hide-details :disabled="pageLoading"
                                class="my-0 py-0 px-0 mx-0 dense-checkbox" color="cyan" />
                        </div>
                        <div class="color-custom-blue py-2 font-weight-700 text-capitalize" :style="{
                            width: '15%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }">
                            #
                        </div>
                        <div class="color-custom-blue py-2 font-weight-700 text-capitalize" :style="{
                            width: '45%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }">
                            Name
                        </div>
                        <div class="color-custom-blue py-2 font-weight-700" :style="{
                            width: '30%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }">
                            Selling/Unit Cost
                        </div>
                    </div>
                    <div style="overflow-y: scroll; max-height: calc(100vh - 360px)">
                        <div v-if="pageLoading" class="my-4 py-4">
                            <v-progress-linear color="cyan" indeterminate rounded height="6"></v-progress-linear>
                        </div>
                        <div v-if="addonList && addonList.length">
                            <div v-for="(row, index) in addonList" :key="index" class="d-flex pt-1 custom_row">
                                <div class="font-weight-600 text-center d-flex justify-center" style="width: 10%;">
                                    <v-checkbox v-model="row.status" hide-details :true-value="true"
                                        :false-value="false" class="my-0 py-0 px-0 mx-0 dense-checkbox" color="cyan" />
                                </div>
                                <div class="text-left"
                                    :style="{ width: '15%', display: 'flex', justifyContent: 'center', alignItems: 'center' }">
                                    <Barcode :barcode="row.barcode"></Barcode>
                                </div>
                                <div class="text-left"
                                    :style="{ width: '45%', display: 'flex', justifyContent: 'center', alignItems: 'center' }">
                                    {{ row.name }}
                                </div>
                                <div class="text-center"
                                    :style="{ width: '30%', display: 'flex', justifyContent: 'center', alignItems: 'center' }">
                                    <v-text-field class="line-item-header-text px-0" placeholder="Selling/Unit Cost"
                                        dense filled solo type="number" v-model="row.price" flat
                                        v-on:keypress="limitDecimal($event, row.price)" color="cyan" />
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                                <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                                Uhh... There are no item at the moment.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { ServiceEventBus } from "@/core/lib/service/service.lib";
import { QUERY } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";

export default {
    name: "line-item-dialog-v2",
    props: {
        addonDialog: {
            type: Boolean,
            default: false,
        },
        selectedAddonList: {
            type: Array,
            default: () => [],
        },
    },
    watch:
    {
        addonDialog:
        {
            deep: true,
            immediate: true,
            handler(param) {
                if (param) {
                    this.find_items();
                }
            }

        }
    },
    data() {
        return {
            search: null,
            category: "all",
            house_type: "all",
            alphabet: "all",
            addonList: [],
            filter_categoty: null,
            filter_house_type: null,
            pageLoading: false
        };
    },
    components: {
        Dialog,
        Barcode
    },
    methods: {
        find_items() {
            let selectedAddonIds = this.lodash.map(this.selectedAddonList, (row) => row.add_on_id);
            this.pageLoading = true;
            this.$store
                .dispatch(QUERY, {
                    url: "addons-list",
                    data: { selectedids: selectedAddonIds, search: this.search }
                })
                .then(({ data }) => {
                    this.addonList = data;
                    this.addonList = data.map(item => ({
                        ...item,
                        status: item.status ?? false 
                    }));
                })
                .catch((error) => {
                    console.log({ error });
                })
                .finally(() => {
                    this.pageLoading = false;
                });
        },
        save_line_item() {
            let selectedAddons = [];
            let status = false;
            for (let item of this.addonList) {
                if (item.status) {
                    status = true;
                    selectedAddons.push(item);
                }
            }
            if (!status) {
                ErrorEventBus.$emit("update:error", `Please select Item.`);
                return false;
            }
            ServiceEventBus.$emit("update:addons", selectedAddons)
            this.$emit("close", true);
        },
        update_all_line_item(status) {
            for (let i = 0; i < this.addonList.length; i++) {
                this.addonList[i].status = status;
                console.log(234, this.addonList[i]);
            }
        },
    },
    computed: {
        dialog_width() {
            return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 60);
        },
        getSelectedItem() {
            return this.addonList.filter((item) => item.status).length;
        },
    },
};
</script>
<style scoped>
.custom_row {
    border-bottom: 1.5px solid #dbd7d7;
}

.custom_row:nth-child(even) {
    background: #fff4de;
}

.custom_row:hover {
    background: #fff4de;
}
</style>
